import React from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import { Link as ReactLink } from "react-router-dom";

import { replaceHashValues } from "utils/replaceHashValues";
import { media } from "utils/style";

import Button from "common-components/Buttons";
import Modal from "common-components/Modal/Modal";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";

const DownloadLimitModal = ({ handleModalState, modalContent, earliestDownloadDate, ...props }) => (
  <Modal contentLabel="download limit reached modal">
   <ModalTitle> <H2>{modalContent.section_title}</H2> </ModalTitle>
   <ModalBody>
    <Div>
      {convertStringToElements(
        replaceHashValues(modalContent.section_description, {
          downloaddate: earliestDownloadDate
        })
      )}
    </Div>
    </ModalBody>
    <div>
      <Button onClick={handleModalState} background={modalContent.buttons[0].type}>
        {modalContent.buttons[0].text}
      </Button>
      {
          window.reactGlobals.amLob.toLowerCase() === "vzw" 
          ? <Link to="/privacy/secure/request-history">{modalContent.links[0].text}</Link>
          : null
      }      
    </div>
  </Modal>
);

export default DownloadLimitModal;

DownloadLimitModal.propTypes = {
  handleModalState: PropTypes.func.isRequired,
  modalContent: PropTypes.object.isRequired,
  earliestDownloadDate: PropTypes.string.isRequired
};

const Link = styled(ReactLink)`
  display: inline-block;
  margin-left: 25px;

  ${media.mobile`
    display: block;
    text-align: center;
    margin-left: 0;
    margin-top: 15px;
  `}
`;

const Div = styled.div`
  max-width: 473px;
  margin-bottom: 40px;
  p {
    padding: 10px 0;
  }
`;

const H2 = styled.h2`
  max-width: 410px;
  margin-bottom: 25px;
`;
